export default "__VITE_ASSET__BAo54tX2__"